import { amber, bgRed, darkGrey, green, headingBlue, maroon, textColor } from "../../../assets/colors";

export const titleStyle = {
    backgroundColor: headingBlue,
    color: 'white',
    fontSize:'1rem',
    display: "flex",
    alignItems: 'center',
    height: "1.8rem", 
    padding: "0.4rem 0rem 0.4rem 1rem"  
}

export const headerGridContainerStyle = {
    padding: '0.75rem 0.25rem 0.75rem 0.25rem'
}

export const headerTextStyle = {
    color: bgRed,
    fontWeight: '600'
}

export const bodyGridStyle = {
    padding: '0.2rem 0rem 0.5rem 0rem'
}

export const idValueBoxStyle = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    // border: '1px solid'
}

export const chapterCodeTextStyle = {
    fontSize: '1rem',
    fontWeight: 600,
}

export const buttonBoxStyle= {
    display:'flex',
    padding: '0.5rem 0rem 0.3rem 0.1rem',
    justifyContent: 'center'
}

export const descriptionBoxStyle = {
    display: 'flex',
    flexDirection: 'row',
    padding: '0.5rem 0rem 0.9rem 0rem'
}

export const descriptionTextStyle = {
    padding: '0.2rem 0.1rem 0.5rem 0.1rem',
    fontSize: '0.9rem',
    alignItems: 'center',
    color: amber
}

export const imageBoxStyle= {
    width: '6rem',
    height: '6.5rem',
    border: `1px solid ${darkGrey}`,
    // borderRadius: `0.5rem`
}

export const imgStyle = {
    width: '5.8rem',
    height: '6.3rem',
    padding: '0.1rem 0.1rem 0.1rem 0.1rem'
}

export const inputBoxStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems:'center',
    // padding: '0.4rem 0.2rem 0.1rem 1.5rem',
    // border: '1px solid'
}